const Header = () => {
  return (
    <div className="border-info-200 flex animate-pulse items-center justify-between border-b px-5 pt-5 pb-6 pl-2">
      <div className="flex flex-col gap-y-2">
        <div className="flex gap-4">
          <div className="rounded-circle bg-info-100 h-8 w-8" />
          <div className="bg-info-200 h-8 w-[220px] rounded-full" />
        </div>
      </div>
      <div className="flex items-center gap-x-2.5">
        <div className="rounded-circle bg-info-100 h-8 w-8" />
        <div className="bg-info-100 h-9 w-36 rounded-md" />
      </div>
    </div>
  );
};

const Drawer = () => {
  return (
    <div className="max-w-drawer flex h-full w-1/3 flex-col gap-3 border-l bg-white px-3 py-6">
      <div className="bg-info-200 h-3 w-3/4 rounded-full" />
      <div className="bg-info-200 h-3 w-1/2 rounded-full" />
      <div className="bg-info-200 h-3 w-3/4 rounded-full" />
      <div className="bg-info-200 h-3 w-3/4 rounded-full" />
    </div>
  );
};

const Page = () => {
  return (
    <div className="micro-interactions z-0 grow overflow-y-scroll pt-36 pb-16">
      <div className="flex flex-col items-center">
        <div
          className="branding page-A4-width relative flex flex-col justify-between border bg-white shadow-md"
          style={{ height: '297mm' }}
        >
          <div className="grid items-center gap-4 p-6">
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-full rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-full rounded-full" />
            <div className="bg-info-200 h-3 w-1/2 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
            <div className="bg-info-200 h-3 w-3/4 rounded-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

const SubHeader = () => {
  return (
    <div className="border-info-200 flex h-[51px] animate-pulse items-center gap-4 border-b bg-white pl-2">
      <div className="rounded-circle bg-info-100 h-4 w-4" />
      <div className="bg-info-200 h-4 w-[320px] rounded-full" />
    </div>
  );
};

export const BrandingLoadingSkeleton = () => {
  return (
    <div role="status" className="flex h-screen w-full flex-col bg-white" data-testid="loading-overlay">
      <Header />

      <div className="bg-info-50 relative flex h-full w-full overflow-hidden overflow-y-hidden">
        <div className="relative flex h-screen w-full flex-col">
          <div className="bg-info-50 flex h-full">
            <div className="flex h-[calc(100vh-77px)] w-full flex-col">
              <SubHeader />
              <Page />
            </div>
            <Drawer />
          </div>
        </div>
      </div>
      <span className="sr-only">Loading...</span>
    </div>
  );
};
